import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface PromotedStory {
  id: number;
  story_id: number;
  story_title: string;
  cover_image: string;
  genre: string;
  language: string;
  episodes_count: number;
  budget: number;
  spent: number;
  views_count: number;
  clicks_count: number;
  status: string;
  created_at: string;
  current_balance: number;
}

export interface SponsoredStory {
  promotion_id: number;
  story_id: number;
  story_title: string;
  story_image: string;
  category: string;
  language: string;
  description: string;
  author_name: string;
  episodes_count: number;
  isSponsored?: boolean;
  sponsoredBadge?: boolean;
  click_cost?: number; 
}

export interface UserStory {
  id: number;
  story_title: string;
  story_image: string;
  description: string;
  genre: string;
  language: string;
  views: number;
  average_rating: number;
  total_ratings: number;
}
export interface SponsoredStoriesResponse {
  status: string;
  sponsored_stories: SponsoredStory[];
  click_cost?: number; 
}
@Injectable({
  providedIn: 'root'
})

export class PromotionService {
  private baseUrl = 'https://stories.funtelstudio.com/storyapi';

  constructor(private http: HttpClient) { }

  // Get user's stories from existing API
  getPublishedStories(userId: string): Observable<{ status: string; data: UserStory[] }> {
  return this.http.get<{ status: string; data: UserStory[] }>(
    `${this.baseUrl}/allstory.php?action=published_stories&user_id=${userId}`,
    { withCredentials: true }
  );
}

// Existing method - ye change nahi karna
getUserStories(): Observable<{ status: string; data: UserStory[] }> {
  return this.http.get<{ status: string; data: UserStory[] }>(
    `${this.baseUrl}/allstory.php?action=myworks`,
    { withCredentials: true }
  );
}

  getSponsoredStories() {
  return this.http.get<SponsoredStoriesResponse>(
    'https://stories.funtelstudio.com/storyapi/promotion_handler.php?action=get_sponsored_stories',
    { withCredentials: true }
  );
}

  // Get promoted stories analytics
  getPromotedStories(): Observable<{ status: string; promoted_stories: PromotedStory[] }> {
    return this.http.get<{ status: string; promoted_stories: PromotedStory[] }>(
      `${this.baseUrl}/promotion_handler.php?action=get_promoted_stories`,
      { withCredentials: true }
    );
  }

  // Get random sponsored story for display
  getSponsoredStory(): Observable<{ status: string; sponsored_story: SponsoredStory | null }> {
    return this.http.get<{ status: string; sponsored_story: SponsoredStory | null }>(
      `${this.baseUrl}/promotion_handler.php?action=get_sponsored_story`
    );
  }

  // Promote a story
  promoteStory(storyId: number, budget: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/promotion_handler.php?action=promote_story`, {
      story_id: storyId,
      budget: budget
    }, { withCredentials: true });
  }

  // ✅ FIXED: Record view or click - ACCEPT NULL VALUES
  recordInteraction(promotionId: number, type: 'view' | 'click', viewerUserId?: number | null): Observable<any> {
    const payload: any = {
      promotion_id: promotionId,
      type: type
    };
    
    // ✅ Only add viewer_user_id if it exists and is not null
    if (viewerUserId !== null && viewerUserId !== undefined) {
      payload.viewer_user_id = viewerUserId;
    }
    
    return this.http.post(`${this.baseUrl}/promotion_handler.php?action=record_interaction`, payload);
  }

  getPromotionBalance(): Observable<{ status: string; promotion_balance: number }> {
    return this.http.get<{ status: string; promotion_balance: number }>(
      `${this.baseUrl}/promotion_handler.php?action=get_promotion_balance`,
      { withCredentials: true }
    );
  }
}